import { MatrixExtract } from '@svgdotjs/svg.js';
import { Editor } from 'Pods/editor/editor';
import { HistoryEvent } from 'Pods/editor/history';

const moveFactor = 5;
let originalMatrix: MatrixExtract;

export const handleEventTransformations = function() {
    let buttonsTransformElements = document.querySelectorAll('.detail__editor__display button');
    originalMatrix = Editor.draw.find('g')[0].transform();
    buttonsTransformElements.forEach(element => {
        element?.removeEventListener('click', transform);
        element?.addEventListener('click', transform);
    });
    let rangeScaleElement = document.querySelector('.detail__editor__display input[type="range"]') as HTMLInputElement;
    rangeScaleElement?.removeEventListener('input', scaleFromRange);
    rangeScaleElement?.addEventListener('input', scaleFromRange);

    let inputScaleElement = document.querySelector('.detail__editor__display input[type="number"]') as HTMLInputElement;
    inputScaleElement?.removeEventListener('change', scaleFromRange);
    inputScaleElement?.addEventListener('change', scaleFromRange);
};

const transform = function(e: Event) {
    let buttonTransformElement = e.currentTarget as HTMLElement;
    let action = buttonTransformElement.dataset.action;
    let value = buttonTransformElement.dataset.values;
    if (value && action) {
        switch (action) {
            case 'move':
                move(value);
                break;
            case 'rotate':
                rotate(value);
                break;
            case 'flip':
                flip(value);
                break;
        }
    }
    let event: HistoryEvent = {
        type: action || '',
        data: Editor.draw.find('g')[0].transform(),
    };

    if (Editor.history) {
        Editor.history.push(event);
    }
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
    Editor.setAlertAndDownloadButton(false);
};

const scaleFromRange = function(e: Event) {
    e.stopPropagation();
    let element = e.currentTarget as HTMLInputElement;
    if (element.type == 'range') {
        scale(parseFloat(element.value), false, true);
    } else {
        scale(parseFloat(element.value), true, false);
    }
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
    Editor.setAlertAndDownloadButton(false);
};

export const scale = function(value: number, modifyRange: boolean, modifyInput: boolean) {
    let scaleX = Editor.draw.find('g')[0].transform().scaleX || 0;
    let scaleY = Editor.draw.find('g')[0].transform().scaleY || 0;

    scaleX = Math.round(scaleX * 100) / 100;
    scaleY = Math.round(scaleY * 100) / 100;

    if (scaleX && scaleY) {
        let newScaleX = ((1 / scaleX) * value) / 100;
        let newScaleY = ((1 / scaleY) * value) / 100;

        Editor.draw.find('g')[0]?.scale(newScaleX, newScaleY);
    }
    if (modifyRange) {
        let rangeSizeElement = document.querySelector(
            '.detail__editor__display input[type="range"]',
        ) as HTMLInputElement;
        rangeSizeElement.value = value.toString();
    }
    if (modifyInput) {
        let inputSizeElement = document.querySelector(
            '.detail__editor__display input[type="number"]',
        ) as HTMLInputElement;
        inputSizeElement.value = value.toString();
    }
    let event: HistoryEvent = {
        type: 'scale',
        data: Editor.draw.find('g')[0].transform(),
    };
    if (Editor.history) {
        Editor.history.push(event);
    }
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
};

const move = function(value: string) {
    let element = Editor.draw.find('g')[0];
    let [top, right, bottom, left] = value.split(' ');
    let x = (parseInt(left) * -1 + parseInt(right)) * moveFactor;
    let y = (parseInt(top) * -1 + parseInt(bottom)) * moveFactor;
    // @ts-ignore
    element.transform({ translateX: x, translateY: y }, element.transform());
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
    Editor.setAlertAndDownloadButton(false);
};

const rotate = function(value: string) {
    // @ts-ignore
    Editor.draw.find('g')[0].transform({ rotate: value }, Editor.draw.find('g')[0].transform());
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
    Editor.setAlertAndDownloadButton(false);
};

const flip = function(value: string) {
    // @ts-ignore
    Editor.draw.find('g')[0].transform({ flip: value }, Editor.draw.find('g')[0].transform());
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
    Editor.setAlertAndDownloadButton(false);
};

export const restore = function(matrix: MatrixExtract | true) {
    Editor.draw.find('g')[0].transform(matrix === true ? originalMatrix : matrix);
    resetValues();
};

export const resetValues = function() {
    let rangeSizeElement = document.querySelector('.detail__editor__display input[type="range"]') as HTMLInputElement;
    rangeSizeElement.value = '100';
    let inputSizeElement = document.querySelector('.detail__editor__display input[type="number"]') as HTMLInputElement;
    inputSizeElement.value = '100';
};
